import React, { useRef,useState,useEffect  } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';

import axios from 'axios';
import common from '../../../common';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import '../CandidateList/primereact__saga-blue_theme.css';
import 'primereact/resources/primereact.min.css'; // 기본 스타일
import 'primeicons/primeicons.css'; // 아이콘
import 'primeflex/primeflex.css'; // 레이아웃 유틸리티

import styles from '../CandidateList/CandidateList.module.scss';

// 20250609 에디터 추가
import Quill from 'quill'; //에디터
import 'quill/dist/quill.snow.css'; //에디터
import '../../../components/Editor/Editor.scss';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function NomiDetail({ onList, viewType, isCode, isEditIdx }) {
	// 20250609 에디터 추가
	const quillAchiRef = useRef(null);
	const editorAchiRef = useRef(null);
	const quillCareerRef = useRef(null);
	const editorCareerRef = useRef(null);
	const [countAchi, setCountAchi] = useState(0);
	const [countCareer, setCountCareer] = useState(0);

	const { useAlert, useLoading, useConfirm, pToast } = common();
	const { pAlert, AlertComponent } = useAlert();
	const { pLoadingOn, pLoadingOff,LoadingComponent} = useLoading();
    const { pConfirm, ConfirmComponent } = useConfirm();

	const [ formData, setFormData ] = useState({//기본 설정
		email:'',// 2. email >> 1. 인적사항 - 대표이메일
		nameKR:'',// 3. nameKR >> 1.인적사항 - 이름

		registNumber:'',// 6. registNumber >> 1. 인적사항 - 주민번호 7자리 920201-1
		// birth:'',// 7. birth >> 1. 인적사항 - 생년월일 1992-02-01
		// gender:'',// 8. gender >> 1. 인적사항 - 성별

		organizationKR:'',// 9. organizationKR >> 1. 인적사항 - 현직기관명(한글)
		deptKR:'',// 11. deptKR >> 1. 인적사항 - 부서(학과)한글
		positionKR:'',// 13. positionKR >> 1. 인적사항 - 직위(한글)

		addressCode:'',// 15. addressCode >> 1. 인적사항 - 주소우편번호
		address:'',// 16. address >> 1. 인적사항 - 주소
		addressDetail:'',// 17. addressDetail >> 1. 인적사항- 주소 상세

		phone:'',// 18. phone >> 1. 인적사항 - 전화번호 010-1111-9999
		companyCall:'',// 19. companyCall >> 1. 인적사항 - 직장번호 010-1111-9999

		memberGradeNameIDX:'',// 24. memberGradeNameIDX >> 2.회원구분 - (1=일반회원, 2=정회원,4=외국회원)
		workField:'',// 25. workField >> 3.업무분야 - (1=학계 ,2=산업계 ,3=공공분야)
		letterDepartIDX:'',// 26. letterDepartIDX >> 4.해당분과위원회

		achievementRecord:'',// 35. achievementRecord >> 9. 업적자료 - 대표적 업적자료(500자 이내)

		naekCareer:'',// 55. naekCareer >> 13. 공학한림원 내 활동내역

		file:'',

		fileUpload:'',
		fileDel:'',
		thumbnailDel:'',

		nation:'',

		member_name:'',
		member_email:'',
		member_organization:'',

		status_view:0,
	});

	//기본
	const callSet3field = (eve = null, len = null, ref = null) => {
		if(eve && len){
			let maxLen=parseInt(len);
			let ipValue=eve.target.value;
			ipValue = ipValue.replace(/[^\d]/g, '')
			if(ref!==null && ipValue.length === maxLen){
				ref.current.focus();
			}
			if (ipValue.length > maxLen) {
				ipValue = ipValue.slice(0, maxLen);
			}
			eve.target.value=ipValue;
			return ipValue;
		}
	};

	const [registNumber1, setregistNumber1] = useState('');
	const [registNumber2, setregistNumber2] = useState('');
	const registNumber2Ref = useRef(null);
	const onChg_registNumber1 = (e) => {
		const value = callSet3field(e,'6',registNumber2Ref);
		setregistNumber1(value);
		setFormData((prevData) => ({
			...prevData,
			registNumber: `${value}-${registNumber2}`,
		}));
	};
	const onChg_registNumber2 = (e) => {
		const value = callSet3field(e,'4');
		setregistNumber2(value);
		setFormData((prevData) => ({ ...prevData, registNumber: `${registNumber1}-${value}` }));
	};
    const openDaumPostCode = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                setFormData({
                    ...formData,
                    addressCode: data.zonecode,
                    address: data.address,
                });
            },
        }).open();
    };
	const [phone1, setphone1] = useState('');
	const [phone2, setphone2] = useState('');
	const [phone3, setphone3] = useState('');
	const phone2Ref = useRef(null);
	const phone3Ref = useRef(null);
	const onChg_phone1 = (e) => {
		const value = callSet3field(e,'3',phone2Ref);
		setphone1(value);
		setFormData((prevData) => ({ ...prevData, phone: `${value}-${phone2}-${phone3}` }));
	};
	const onChg_phone2 = (e) => {
		const value = callSet3field(e,'4',phone3Ref);
		setphone2(value);
		setFormData((prevData) => ({ ...prevData, phone: `${phone1}-${value}-${phone3}` }));
	};
	const onChg_phone3 = (e) => {
		const value = callSet3field(e,'4');
		setphone3(value);
		setFormData((prevData) => ({ ...prevData, phone: `${phone1}-${phone2}-${value}` }));
	};

	const [companyCall1, setcompanyCall1] = useState('');
	const [companyCall2, setcompanyCall2] = useState('');
	const [companyCall3, setcompanyCall3] = useState('');
	const companyCall2Ref = useRef(null);
	const companyCall3Ref = useRef(null);
	const onChg_companyCall1 = (e) => {
		const value = callSet3field(e,'3',companyCall2Ref);
		setcompanyCall1(value);
		setFormData((prevData) => ({ ...prevData, companyCall: `${value}-${companyCall2}-${companyCall3}` }));
	};
	const onChg_companyCall2 = (e) => {
		const value = callSet3field(e,'4',companyCall3Ref);
		setcompanyCall2(value);
		setFormData((prevData) => ({ ...prevData, companyCall: `${companyCall1}-${value}-${companyCall3}` }));
	};
	const onChg_companyCall3 = (e) => {
		const value = callSet3field(e,'4');
		setcompanyCall3(value);
		setFormData((prevData) => ({ ...prevData, companyCall: `${companyCall1}-${companyCall2}-${value}` }));
	};
	const memberGradeNameIDX = [
		{ key: 'memberGradeNameIDX1', value: '1', name: '정회원' },
		{ key: 'memberGradeNameIDX2', value: '2', name: '일반회원' },
		{ key: 'memberGradeNameIDX4', value: '4', name: '외국회원' },
	]
	const [selected_memberGradeNameIDX, setSelected_memberGradeNameIDX] = useState([]);

	const workField = [
		{ key: 'workField1', value: '1', name: '학계' },
		{ key: 'workField2', value: '2', name: '산업계' },
		{ key: 'workField4', value: '3', name: '공공분야' },
	]
	const [selected_workField, setSelected_workField] = useState([]);
	const onChg_workField = (e) => {
		let selected_ = [];
		if (e.checked) {
			selected_.push(e.value);
			setFormData((prevData) => ({ ...prevData, workField: e.value.value }));
			setSelected_workField(selected_);
		}
	};

	const letterDepartIDX = [
		{ key: 'letterDepartIDX1', value: '1', name: '전기전자공학' },
		{ key: 'letterDepartIDX2', value: '2', name: '기계공학' },
		{ key: 'letterDepartIDX3', value: '3', name: '건설환경공학' },
		{ key: 'letterDepartIDX4', value: '4', name: '화학생물공학' },
		{ key: 'letterDepartIDX5', value: '5', name: '재료자원공학' },
		{ key: 'letterDepartIDX6', value: '6', name: '기술경영정책' },
		{ key: 'letterDepartIDX9', value: '9', name: '컴퓨팅' },
		{ key: 'letterDepartIDX10', value: '10', name: '바이오메디컬' },
	]
	const [selected_letterDepartIDX, setSelected_letterDepartIDX] = useState([]);
	const onChg_letterDepartIDX = (e) => {
		let selected_ = [];
		if (e.checked) {
			selected_.push(e.value);
			setFormData((prevData) => ({ ...prevData, letterDepartIDX: e.value.value }));
			setSelected_letterDepartIDX(selected_);
		}
	};

	// 업적요약서 파일 첨부	
	const MAX_FILE_SIZE_MB = 30;
	const formDataFileCount = formData.file ? formData.file.length : 0;
    const onChg_file = (e) => {
		const newFile = Array.from(e.target.files);

		const existingFileNames = new Set((formData.file || []).map(file => file.name));
		for (const file of newFile) {
			if (existingFileNames.has(file.name)) {
				pAlert('동일한 파일명이 존재합니다!');
				return;
			}
			if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
				pAlert(`"${file.name}" 파일은 ${MAX_FILE_SIZE_MB}MB를 초과하여 업로드할 수 없습니다!`);
				return;
			}
		}

		const newFile_forFront = newFile.map((file, index) => ({
            idx: Date.now() + index,  // 고유 ID 생성
            name: file.name,
            serverName: URL.createObjectURL(file),  // 로컬 파일 URL 생성
            isLocal: true  // 로컬 파일 표시
        }));
        setFormData(prevData => ({
            ...prevData,
            file: [...prevData.file, ...newFile_forFront],
            fileUpload: [...(prevData.fileUpload || []), ...newFile],
        }));
    };
    const on_emptyFile = (fileInfo) => {
		setFormData(prevData => {
			let updatedFiles = (prevData.file || []).filter(file => file && file.idx !== fileInfo.idx);
			let updatedFileUpload = prevData.fileUpload || [];
			let updatedFileDel = prevData.fileDel || [];
			if (fileInfo.isLocal) {
				updatedFileUpload = updatedFileUpload.filter(file => file && file.idx !== fileInfo.idx);
			} else {
				updatedFileDel.push(fileInfo);
			}
			return {
				...prevData,
				file: updatedFiles,
				fileUpload: updatedFileUpload,
				fileDel: updatedFileDel,
			};
		});
    };

	// 20250612 비회원 접근이기 때문에 다운로드를 없앤다.
	// 20250804 요청사항때문에 다시 살린다;
	const on_downloadFile = async (file) => {
        if (file.isLocal) {
            // 로컬 파일의 경우 직접 다운로드
            const link = document.createElement('a');
            link.href = file.serverName;
            link.download = file.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            try {
                pLoadingOn();
                const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/in/get_nomi_file`, {
                    idx: [file.idx],
                    name: file.name
                }, {
                    withCredentials: true,
                    responseType: 'blob'  // 응답 타입을 blob으로 설정
                });

                if (response.status === 200) { // HTTP 응답 상태 코드가 200인 경우
                    const blob = response.data;
                    const downloadUrl = window.URL.createObjectURL(blob);

                    // Blob을 사용하여 파일 다운로드
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = file.name;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Blob URL을 해제
                    window.URL.revokeObjectURL(downloadUrl);
                } else {
                    pAlert('파일 다운로드에 실패했습니다.');
                }
            } catch (error) {
                pAlert(`파일다운에 실패했습니다. 다시 시도해 주세요.`);
            } finally {
                pLoadingOff();
            }
        }
    };
	
	useEffect(() => {
		if(viewType=='edit' || viewType=='nominee'){
			//
		}
		if(viewType=='edit' && isCode){
			getDetail('e',isCode);
			//수정해야함 idx가 아니라 암호화된 코드로
		}
		if(viewType=='nominee' && isCode){
			getDetail('n',isCode);
		}
	}, [viewType, isEditIdx, isCode]);

	const getDetail = async (type,idx) => {
        try {
            pLoadingOn();
			let postFunPath = type === 'e' ? 'out/get_detail' : 'out/get_detail';
			const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/${postFunPath}`, { code:idx }, { withCredentials: true });
			
            if (response && response.data && response.data.result === 't') {
                setDetailFormData(response.data.data);
				if(type==='go_submit'){
					nomineeEdit('submit')
				}
            } else {
                console.error(response.data);
				pAlert(response.data.msg);
				if (type === 'e') {
				} else if (type === 'n') {
				}
            }
        } catch (error) {
            console.error('실패:', error);
        } finally {
            setTimeout(() => {
                pLoadingOff();
            }, 300);
        }
    };

	const [ GetDeOriFormData, setGetDeOriFormData ] = useState([]);
    const setDetailFormData = (data) => {
		setFormData(data);
		setGetDeOriFormData(data);

		const Parts_registNumber = (data.registNumber || '').split('-');
		setregistNumber1(Parts_registNumber[0] || '');
		setregistNumber2(Parts_registNumber[1] || '');
		
		const Parts_phone = (data.phone || '').split('-');
		setphone1(Parts_phone[0] || '');
		setphone2(Parts_phone[1] || '');
		setphone3(Parts_phone[2] || '');

		const Parts_companyCall = (data.companyCall || '').split('-');
		setcompanyCall1(Parts_companyCall[0] || '');
		setcompanyCall2(Parts_companyCall[1] || '');
		setcompanyCall3(Parts_companyCall[2] || '');

		const temp_memberGradeNameIDX = memberGradeNameIDX.find(category => category.value === (data.memberGradeNameIDX || '').toString());
		setSelected_memberGradeNameIDX(temp_memberGradeNameIDX ? [temp_memberGradeNameIDX] : []);
		
		const temp_workField = workField.find(category => category.value === (data.workField || '').toString());
		setSelected_workField(temp_workField ? [temp_workField] : []);
		
		const temp_letterDepartIDX = letterDepartIDX.find(category => category.value === (data.letterDepartIDX || '').toString());
		setSelected_letterDepartIDX(temp_letterDepartIDX ? [temp_letterDepartIDX] : []);

		if (quillAchiRef.current) {
			const quillAchi = quillAchiRef.current;
			const editorAchi = quillAchi.root;
			editorAchi.innerHTML = data.achievementRecord || '';
		}
		
		if (quillCareerRef.current) {
			const quillCareer = quillCareerRef.current;
			const editorCareer = quillCareer.root;
			editorCareer.innerHTML = data.naekCareer || '';
		}
	};

	const fieldNames = {
		memberGradeNameIDX:'1. 지원 부문 - 회원 구분',
		letterDepartIDX:'1. 지원 부문 - 전문 분과',
		workField:'1. 지원 부문 - 업무 분야',
		nameKR:'2. 지원자 인적사항 - 성명',
		registNumber:'2. 지원자 인적사항 - 주민등록번호',
		nation:'2. 지원자 인적사항 - 국적',
		organizationKR:'2. 지원자 인적사항 - 기관(한글)',
		deptKR:'2. 지원자 인적사항 - 부서(한글)',
		positionKR:'2. 지원자 인적사항 - 직위(한글)',
		addressCode:'2. 지원자 인적사항 - 직장주소 우편번호',
		address:'2. 지원자 인적사항 - 직장주소',
		addressDetail:'2. 지원자 인적사항 - 장주소 상세',
		companyCall:'2. 지원자 인적사항 - 직장번호',
		phone:'2. 지원자 인적사항 - 휴대전화',
		email:'2. 지원자 인적사항 - 이메일',
		achievementRecord:'3. 업적',
		naekCareer:'4. 공학한림원 활동 내역 및 계획',
		// file:'업적요약서 파일'
	};
	const updateFieldValues = (changedData, originalData, fieldNames) => {
		const diffData = {};
		let changes = [];

		if (changedData.fileDel && changedData.fileDel.length > 0) {
			changedData.fileDel.forEach((file) => {
				changes.push(['첨부 파일 삭제', file.name, '']);
			});
			diffData['fileDel'] = JSON.stringify(changedData.fileDel);
		}
		if (changedData.fileUpload && changedData.fileUpload.length > 0) {
			changedData.fileUpload.forEach((file) => {
				changes.push(['첨부 파일 추가', '', file.name]);
			});
			diffData['fileUpload'] = changedData.fileUpload;
		}

		Object.keys(changedData).forEach(key => {
			if (fieldNames[key]) {
				if (JSON.stringify(changedData[key]) !== JSON.stringify(originalData[key])) {
					if (['file'].includes(key)) {
						// fileDel
					}else if (['memberGradeNameIDX', 'workField', 'letterDepartIDX'].includes(key)) {
						const getNameFromCategory = (key, originalValue, changedValue, categories) => {
							const originalName = categories.find(category => category.value === originalValue?.toString())?.name || '';
							const changedName = categories.find(category => category.value === changedValue?.toString())?.name || '';
							changes.push([fieldNames[key], originalName, changedName]);
						};
						if (key === 'memberGradeNameIDX') {
							getNameFromCategory(key, originalData.memberGradeNameIDX, changedData.memberGradeNameIDX, memberGradeNameIDX);
						} else if (key === 'workField') {
							getNameFromCategory(key, originalData.workField, changedData.workField, workField);
						} else if (key === 'letterDepartIDX') {
							getNameFromCategory(key, originalData.letterDepartIDX, changedData.letterDepartIDX, letterDepartIDX);
						}

						diffData[key] = changedData[key];
					}else{
						diffData[key] = changedData[key];
						if (changedData[key] === '' || changedData[key] === null) {
							changes.push([fieldNames[key], originalData[key], '내용 삭제']);
						} else {
							changes.push([fieldNames[key], originalData[key] || '없음', changedData[key]]);
						}
					}
				}
			}
		});
		return { diffData, changes };
	};

	const [UpdatedReady, setUpdatedReady] = useState(false);
	const [UpdatedType, setUpdatedType] = useState('');






































	
	// useEffect(() => {
    //     if (UpdatedReady) {
    //         const submitData = async () => {
    //             try {
	// 				if(UpdatedType==='save'){
	// 					const { diffData, changes } = updateFieldValues(formData, GetDeOriFormData, fieldNames);
	// 					if(Object.keys(diffData).length>0){
	// 						pConfirm(
	// 							'수정',
	// 							<>
	// 								<div>해당 내용을 수정 하시겠습니까?</div>
	// 								<div className='naek_table nomi_changed_confirm_table'>
	// 									<div className='p-datatable'>
	// 										<table>
	// 											<thead>
	// 												<tr>
	// 													<th></th>
	// 													<th>변경 전</th>
	// 													<th>변경 후</th>
	// 												</tr>
	// 											</thead>
	// 											<tbody>
	// 												{changes
	// 												.sort((a, b) => a[0].localeCompare(b[0])) // 필드 이름 기준으로 오름차순 정렬
	// 												.map(([field, before, after], index) => (
	// 													<tr key={index}>
	// 														<td>{field}</td>
	// 														<td dangerouslySetInnerHTML={{ __html: before }}></td>
	// 														<td dangerouslySetInnerHTML={{ __html: after }}></td>
	// 													</tr>
	// 												))}
	// 											</tbody>
	// 										</table>
	// 									</div>
	// 								</div>
	// 								<div>수정이 완료되면 데이터를 되돌릴 수 없습니다!</div>
	// 							</>,
	// 							'auto',
	// 							'auto',
	// 							async () => {
	// 								try {
	// 									pLoadingOn();
					
	// 									const realFormData = new FormData();
	// 									realFormData.append('targetIdx', formData.idx);
	// 									// realFormData.append('member_idx', formData.idx); //이걸 왜 보내고 있지
	// 									realFormData.append('type', UpdatedType);

	// 									Object.entries(diffData).forEach(([key, value]) => {
	// 										if (key !== 'fileUpload') {
	// 											realFormData.append(key, value);
	// 										}
	// 									});
	// 									if (diffData.fileUpload && diffData.fileUpload.length > 0) {
	// 										diffData.fileUpload.forEach((file) => {
	// 											realFormData.append('file', file);
	// 										});
	// 									}
	// 									const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/out/submit_nomi`, realFormData, {
	// 										withCredentials: true,
	// 										headers: {
	// 											'Content-Type': 'multipart/form-data'
	// 										}
	// 									});
	// 									if (response.data.result === 't') {
	// 										getDetail('n',isCode);
	// 									}
	// 									pAlert(response.data.msg);
	// 								} catch (error) {
	// 									console.error('등록 실패:', error);
	// 								} finally {
	// 									pLoadingOff();
	// 								}
	// 							}
	// 						);
	// 					}else{
	// 						pAlert('수정된 내용이 없습니다!');
	// 					}
	// 				}
	// 				if(UpdatedType==='submit'){
	// 					// 유효성 검사
	// 					const { diffData, changes } = updateFieldValues(formData, GetDeOriFormData, fieldNames);
	// 					pConfirm(
	// 						'지원서 제출',
	// 						<>
	// 							<div>지원서를 제출 하시겠습니까?</div>
	// 							{Object.keys(diffData).length>0 &&
	// 								<div className='naek_table nomi_changed_confirm_table'>
	// 									<div className='p-datatable'>
	// 										<table>
	// 											<thead>
	// 												<tr>
	// 													<th></th>
	// 													<th>변경 전</th>
	// 													<th>변경 후</th>
	// 												</tr>
	// 											</thead>
	// 											<tbody>
	// 												{changes
	// 												.sort((a, b) => a[0].localeCompare(b[0])) // 필드 이름 기준으로 오름차순 정렬
	// 												.map(([field, before, after], index) => (
	// 													<tr key={index}>
	// 														<td>{field}</td>
	// 														<td dangerouslySetInnerHTML={{ __html: before }}></td>
	// 														<td dangerouslySetInnerHTML={{ __html: after }}></td>
	// 													</tr>
	// 												))}
	// 											</tbody>
	// 										</table>
	// 									</div>
	// 								</div>
	// 							}
	// 							<div>* 지원서 제출이 완료되면 추천자에게 추천서 작성 요청 이메일이 발송되며, 내용을 수정할 수 없습니다.</div>
	// 						</>,
	// 						'auto',
	// 						'auto',
	// 						async () => {
	// 							try {
	// 								pLoadingOn();
				
	// 								const realFormData = new FormData();
	// 								realFormData.append('targetIdx', formData.idx);
	// 								realFormData.append('type', UpdatedType);

	// 								Object.entries(diffData).forEach(([key, value]) => {
	// 									if (key !== 'fileUpload') {
	// 										realFormData.append(key, value);
	// 									}
	// 								});
	// 								if (diffData.fileUpload && diffData.fileUpload.length > 0) {
	// 									diffData.fileUpload.forEach((file) => {
	// 										realFormData.append('file', file);
	// 									});
	// 								}
	// 								const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/out/submit_nomi`, realFormData, {
	// 									withCredentials: true,
	// 									headers: {
	// 										'Content-Type': 'multipart/form-data'
	// 									}
	// 								});
	// 								if (response.data.result === 't') {
	// 									getDetail('n',isCode);
	// 								}
	// 								pAlert(response.data.msg);
	// 							} catch (error) {
	// 								console.error('등록 실패:', error);
	// 							} finally {
	// 								pLoadingOff();
	// 							}
	// 						}
	// 					);
	// 				}
	// 			} catch (error) {
    //                 // console.error('Error submitting data:', error);
    //             }
    //         };
    //         submitData();
    //         setUpdatedReady(false); // 상태가 업데이트 되었음을 초기화
    //     }
    // }, [formData, UpdatedReady]);


























	
	useEffect(() => {
        if (UpdatedReady) {
            const submitData = async () => {
                try {
					// if(UpdatedType==='save'){
						const { diffData, changes } = updateFieldValues(formData, GetDeOriFormData, fieldNames);
						if(Object.keys(diffData).length>0){
							const confirmTitle = UpdatedType === 'submit' ? '제출' : '저장';
							const confirmMessage = UpdatedType === 'submit'
							? '지원서를 제출하기 전 아래 내용으로 지원서 내용이 저장됩니다.'
							: '아래 내용으로 저장 하시겠습니까?';
							pConfirm(
								confirmTitle,
								<>
									<div>{confirmMessage}</div>
									<div className='naek_table nomi_changed_confirm_table'>
										<div className='p-datatable'>
											<table>
												<thead>
													<tr>
														<th></th>
														<th>변경 전</th>
														<th>변경 후</th>
													</tr>
												</thead>
												<tbody>
													{changes
													.sort((a, b) => a[0].localeCompare(b[0])) // 필드 이름 기준으로 오름차순 정렬
													.map(([field, before, after], index) => (
														<tr key={index}>
															<td>{field}</td>
															<td dangerouslySetInnerHTML={{ __html: before }}></td>
															<td dangerouslySetInnerHTML={{ __html: after }}></td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</div>
									<div></div>
								</>,
								'auto',
								'auto',
								async () => {
									try {
										pLoadingOn();
					
										const realFormData = new FormData();
										realFormData.append('targetIdx', formData.idx);
										// realFormData.append('type', UpdatedType);
										realFormData.append('type', 'save');

										Object.entries(diffData).forEach(([key, value]) => {
											if (key !== 'fileUpload') {
												realFormData.append(key, value);
											}
										});
										if (diffData.fileUpload && diffData.fileUpload.length > 0) {
											diffData.fileUpload.forEach((file) => {
												realFormData.append('file', file);
											});
										}
										const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/out/submit_nomi`, realFormData, {
											withCredentials: true,
											headers: {
												'Content-Type': 'multipart/form-data'
											}
										});
										if (response.data.result === 't') {
											
											if(UpdatedType==='save'){
												getDetail('n',isCode);
											}
											if(UpdatedType==='submit'){
												getDetail('go_submit',isCode);
											}
										}
										pAlert(response.data.msg);
									} catch (error) {
										console.error('등록 실패:', error);
									} finally {
										pLoadingOff();
									}
								}
							);
						}else{
							if(UpdatedType==='save'){
								pAlert('변경된 내용이 없습니다!');
							}
							if(UpdatedType==='submit'){
								const today = new Date(); // 예: 2025-06-25 기준

								const year = today.getFullYear();
								const month = today.getMonth() + 1; // 월은 0부터 시작하므로 +1
								const date = today.getDate();

								const todayFormatted = `${year}년 ${month}월 ${date}일`;
								const { diffData, changes } = updateFieldValues(formData, GetDeOriFormData, fieldNames);
								pConfirm(
									'한국공학한림원 회원 후보자 개인정보 수집 · 이용 · 제공 동의',
									<>
										<div className='nomi_f_top_info'>
											<span>한국공학한림원은 회원 지원서 접수 및 심사 과정에서 후보자의 개인정보를 수집·이용하고 있으며, 회원으로 선출 시 제출하신 모든 정보를 계속하여 활용하고자 합니다.</span>
											<span>다음 사항에 대해 일괄 동의를 하시는 경우, 회원 선출 후에도 추가 확인 절차 없이 후보자가 제공한 정보를 이용합니다.</span>
										</div>
										<div className='nomi_f_table_wrap'>
<table className='nomi_f_table'>
	<tbody>
	<tr>
		<td className='nomi_f_tbl_big_tit' colSpan={2}>1. 개인정보 수집 · 이용에 관한 사항</td>
	</tr>
	<tr>
		<td className='nomi_f_tbl_tit'>수집 · 이용 목적</td>
		<td className='nomi_f_tbl_con'>￭ 지원서 접수 ￭ 후보자 심사의 기초자료 ￭ 심사관련 정보 안내<br />￭ 기관 홈페이지 및 회원 디지털 아카이브 회원 정보 공개(회원 선출시)</td>
	</tr>
	<tr>
		<td className='nomi_f_tbl_tit'>수집 · 이용 항목 </td>
		<td className='nomi_f_tbl_con'>￭ 성명, 생년월일, 전화번호, 휴대폰 번호, 이메일, 소속, 학력, 경력, 연구 업적, 제재정보(NTIS) 등</td>
	</tr>
	<tr>
		<td className='nomi_f_tbl_tit'>보유 · 이용 기간</td>
		<td className='nomi_f_tbl_con'>위 개인정보는 수집 · 이용에 관한 동의일로부터 수집 · 이용 목적을 달성할 때까지 보유 · 이용됩니다.</td>
	</tr>
	{/* <tr>
		<td className='nomi_f_tbl_tit nomi_f_tbl_bg'>수집 · 이용동의 여부</td>
		<td className='nomi_f_tbl_con nomi_f_tbl_bg'>ㅁ 위와 같이 개인정보를 수집 · 이용하는데 동의합니다.</td>
	</tr> */}
	<tr>
		<td className='nomi_f_tbl_big_tit' colSpan={2}>2. 개인정보 제3자 제공에 관한 사항</td>
	</tr>
	<tr>
		<td className='nomi_f_tbl_tit'>제공받는 자</td>
		<td className='nomi_f_tbl_con'>￭ 회원 추천 시(추천자)<br />￭ 회원 심사 시(전문분과위원회, 회원위원회)<br />￭ 회원 선출 후(전문분과위원회 등)</td>
	</tr>
	<tr>
		<td className='nomi_f_tbl_tit'>제공 목적</td>
		<td className='nomi_f_tbl_con'>￭ 회원의 전문성 활용을 통한 공학한림원 고유사업 추진<br />￭ 언론, 정부부처, 유관기관 요청 전문가(자문, 심사, 전문 위원 등) 추천<br />￭ 기관 홈페이지 및 회원 디지털 아카이브 등을 통한 일반 대중 홍보</td>
	</tr>
	<tr>
		<td className='nomi_f_tbl_tit'>제공 항목</td>
		<td className='nomi_f_tbl_con'>￭ 성명, 소속, 전공분야, 학력, 경력, 연구 업적 등</td>
	</tr>
	{/* <tr>
		<td className='nomi_f_tbl_tit nomi_f_tbl_bg'>개인정보 제3자<br />제공 동의 여부</td>
		<td className='nomi_f_tbl_con nomi_f_tbl_bg'>ㅁ 위와 같이 개인정보 제3자 제공에 동의합니다.</td>
	</tr> */}
	</tbody>
</table>
										</div>
										<div className='nomi_f_bot_info'>
											<span>※ 귀하는 개인정보 제공 및 동의를 거부할 권리가 있으며, 위 항목 동의 거부 시 후보자 추천 접수에 제한을 받으실 수 있습니다. 또한 개인정보 제공자가 동의한 내용 외의 다른 목적으로 활용하지 않으며, 제공한 개인정보의 이용을 거부하고자 할 때에는 개인정보 관리책임자를 통해 열람, 정정, 삭제를 요구할 수 있습니다.</span>
										</div>
										<div className='nomi_f_foot_wrap'>
											<span className='nomi_f_f_date'>{todayFormatted}</span>
											<div className='nomi_f_f_mem_wrap'>

												<div className='nomi_f_f_mem_row'>
													<div className='nomi_f_f_tit_box'>
														<span className='nomi_f_f_tit'>소 속</span>
														<span className='forjustify'></span>
													</div>
													<span className='nomi_f_f_con'> : {formData.organizationKR}</span>
												</div>
												<div className='nomi_f_f_mem_row'>
													<div className='nomi_f_f_tit_box'>
														<span className='nomi_f_f_tit'>지 원 자</span>
														<span className='forjustify'></span>
													</div>
													<span className='nomi_f_f_con'> : {formData.nameKR}</span>
												</div>
											</div>
										</div>
									</>,
									'auto',
									'auto',
									async () => {
										try {
											pLoadingOn();
						
											const realFormData = new FormData();
											realFormData.append('targetIdx', formData.idx);
											realFormData.append('type', UpdatedType);

											Object.entries(diffData).forEach(([key, value]) => {
												if (key !== 'fileUpload') {
													realFormData.append(key, value);
												}
											});
											if (diffData.fileUpload && diffData.fileUpload.length > 0) {
												diffData.fileUpload.forEach((file) => {
													realFormData.append('file', file);
												});
											}
											const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/out/submit_nomi`, realFormData, {
												withCredentials: true,
												headers: {
													'Content-Type': 'multipart/form-data'
												}
											});
											if (response.data.result === 't') {
												getDetail('n',isCode);
											}
											pAlert(response.data.msg);
										} catch (error) {
											console.error('등록 실패:', error);
										} finally {
											pLoadingOff();
										}
									},
									'위와 같이 개인정보를 수집 · 이용 · 제공하는데 동의합니다.',//확인버튼 텍스트
									'',//취소버튼 텍스트
									'nomi_final_agree_tit',//제목 클래스명
									'nomi_final_agree_con',//콘텐츠 클래스명
									'nomi_final_agree_btn_box',//모달 컨텐츠 클래스명
								);
							}
						}
					// }

























				} catch (error) {
                    // console.error('Error submitting data:', error);
                }
            };
            submitData();
            setUpdatedReady(false); // 상태가 업데이트 되었음을 초기화
        }
    }, [formData, UpdatedReady]);
















































	const nomineeEdit = async (action) => {
		if(countAchi > maxLenAchi){
			return pAlert(`${fieldNames['achievementRecord']} 의 글자수가 초과되었습니다! (${countAchi} / ${maxLenAchi})`);
		}
		if(countCareer > maxLenCareer){
			return pAlert(`${fieldNames['naekCareer']} 의 글자수가 초과되었습니다! (${countCareer} / ${maxLenCareer})`);
		}
		let AchiContent = quillAchiRef.current.root.innerHTML; //
		if (!AchiContent || AchiContent.trim() === '<p><br></p>') {
			AchiContent=null;
		}
		let CareerContent = quillCareerRef.current.root.innerHTML; //
		if (!CareerContent || CareerContent.trim() === '<p><br></p>') {
			CareerContent=null;
		}
		if (action ==='submit'){
			// if ((formData.workField).toString() !== '1' && (formData.workField).toString() !== '2' && (formData.workField).toString() !== '3'){
			// 	return pAlert('업무 분야를 선택해주세요.');
			// }
			if (
				formData.workField == null ||  // null 또는 undefined 체크
				!['1', '2', '3'].includes(formData.workField.toString())
			) {
				return pAlert('업무 분야를 선택해주세요.');
			}
			if ((formData.registNumber || '').toString().length !== 8){
				return pAlert('주민등록번호를 정확하게 입력해 주세요.');
			}
			if ((formData.organizationKR || '').toString().length < 2){
				return pAlert('현직 기관명을 정확하게 입력해 주세요.');
			}
			// if ((formData.deptKR || '').toString().length < 2){
			// 	return pAlert('현직 부서명을 정확하게 입력해 주세요.');
			// }
			if ((formData.positionKR || '').toString().length < 2){
				return pAlert('현직 직위를 정확하게 입력해 주세요.');
			}
			// if ((formData.addressCode || '').toString().length !== 5){
			// 	return pAlert('직장주소를 정확하게 입력해 주세요.');
			// }
			// if ((formData.address || '').toString().length < 2){
			// 	return pAlert('직장주소를 정확하게 입력해 주세요.');
			// }
			// if ((formData.addressDetail || '').toString().length < 2){
			// 	return pAlert('직장 상세주소를 정확하게 입력해 주세요.');
			// }
			if ((formData.phone || '').toString().length < 12){
				return pAlert('휴대 전화를 정확하게 입력해 주세요.');
			}
			// if ((formData.companyCall || '').toString().length < 10){
			// 	return pAlert('직장 번호를 정확하게 입력해 주세요.');
			// }
			if ((formData.email || '').toString().length < 7){
				return pAlert('이메일을 정확하게 입력해 주세요.');
			}
			if (!AchiContent || AchiContent.trim() === '<p><br></p>') {
				return pAlert('업적을 입력해 주세요.');
			}
			if (!CareerContent || CareerContent.trim() === '<p><br></p>') {
				return pAlert('공학한림원 활동 내역 및 계획을 입력해 주세요.');
			}
			if (formData.file.length < 1){
				return pAlert('파일을 첨부해주세요.');
			}
		}
		setFormData((prevData) => ({
			...prevData,
			achievementRecord: AchiContent,
			naekCareer: CareerContent
		}))
		setUpdatedReady(true);
		setUpdatedType(action);
	};

	// 정회원이 피추천자가 승인한 지명추천서를 승인한다.
	// const memberConfirm = async () => {
	// 	pConfirm(
	// 		'승인',
	// 		<>
	// 			<div>승인 하시겠습니까?</div>
	// 		</>,
	// 		'auto',
	// 		'auto',
	// 		async () => {
	// 			try {
	// 				pLoadingOn();
	// 				const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/in/member_sign_up_nomi`, { targetIdx: formData.idx }, { withCredentials: true });
	// 				if (response && response.data && response.data.result === 't') {
	// 					getDetail('n',isCode);
	// 				}
	// 				pAlert(response.data.msg);
	// 			} catch (error) {
	// 				console.error('실패:', error);
	// 			} finally {
	// 				setTimeout(() => {
	// 					pLoadingOff();
	// 				}, 300);
	// 			}
	// 		}
	// 	);
	// };


	// 20250609 에디터 추가
	const handleDrop = async (event) => {
		event.preventDefault();
		event.stopPropagation();
	};
	const handleDragOver = (event) => {
		event.preventDefault();
		event.stopPropagation();
	};
	const maxLenAchi = 2500;
	const maxLenCareer = 1000;
	const quillOptions = {
		theme: 'snow',
		modules: {
			toolbar: {
			container: [
				['bold', 'underline', { color: [] }],
			],
			},
		},
		formats: ['bold', 'underline', 'color'],
	};
	useEffect(() => {
		if (editorAchiRef.current) {
			const quill = new Quill(editorAchiRef.current, quillOptions);
			quillAchiRef.current = quill;
			
			quill.on('text-change', function (delta, oldDelta, source) {
				const plainText = quill.getText(); // 개행 포함 전체 문자열
				setCountAchi(plainText.length - 1);
			});

			quill.root.addEventListener('drop', handleDrop, true);
			quill.root.addEventListener('dragover', handleDragOver, true);

			const editorContainer = editorAchiRef.current;
			editorContainer.addEventListener('drop', handleDrop);
			editorContainer.addEventListener('dragover', handleDragOver);

			setTimeout(() => {
				const editorRoot = quill.root;
				const emptyTags = editorRoot.querySelectorAll('div:empty, p:empty');
				emptyTags.forEach(tag => {
					tag.remove();
				});
				const emptyLineTags = editorRoot.querySelectorAll('p');
				emptyLineTags.forEach(tag => {
					if (tag.innerHTML.trim() === '' || tag.innerHTML === '<br>') {
						tag.remove();
					}
				});
			}, 500);
			return () => {
				quill.root.removeEventListener('drop', handleDrop, true);
				quill.root.removeEventListener('dragover', handleDragOver, true);
				editorContainer.removeEventListener('drop', handleDrop);
				editorContainer.removeEventListener('dragover', handleDragOver);
			};
		}
	}, []);
	useEffect(() => {
		if (editorCareerRef.current) {
			const quill = new Quill(editorCareerRef.current, quillOptions);
			quillCareerRef.current = quill;
			quill.on('text-change', function (delta, oldDelta, source) {
				const plainText = quill.getText(); // 개행 포함 전체 문자열
				setCountCareer(plainText.length - 1);
			});

			quill.root.addEventListener('drop', handleDrop, true);
			quill.root.addEventListener('dragover', handleDragOver, true);

			const editorContainer = editorCareerRef.current;
			editorContainer.addEventListener('drop', handleDrop);
			editorContainer.addEventListener('dragover', handleDragOver);

			setTimeout(() => {
				const editorRoot = quill.root;
				const emptyTags = editorRoot.querySelectorAll('div:empty, p:empty');
				emptyTags.forEach(tag => {
					tag.remove();
				});
				const emptyLineTags = editorRoot.querySelectorAll('p');
				emptyLineTags.forEach(tag => {
					if (tag.innerHTML.trim() === '' || tag.innerHTML === '<br>') {
						tag.remove();
					}
				});
			}, 500);
			return () => {
				quill.root.removeEventListener('drop', handleDrop, true);
				quill.root.removeEventListener('dragover', handleDragOver, true);
				editorContainer.removeEventListener('drop', handleDrop);
				editorContainer.removeEventListener('dragover', handleDragOver);
			};
		}
	}, []);

	return (
		<>
		<AlertComponent />
		<LoadingComponent />
		<ConfirmComponent />
		<div className='components_wrap'>
			{ viewType=='nominee' && isCode &&
				<>
				<div className={`${styles.info_box}`}>
					{ formData.status_view === 1 &&
						<>
						<span className='f_normal before_required'><b>{formData.nameKR}{formData.nameEN && formData.nameEN!=='' && `(${formData.nameEN})`}</b> 님 안녕하세요. 아래 지원서 양식을 작성하시고 제출 버튼을 눌러주세요.</span>
						<div className="pd5"></div>
						<span className='f_normal before_required'>뒤로가기나 화면을 종료하면 저장되지 않습니다. 임시저장 버튼을 눌러 데이터를 저장해주세요.</span>
						<div className="pd5"></div>
						</>
					}
					{ formData.status_view === 2 &&
						<>
						<span className='f_normal before_required'>제출이 완료된 지원서 입니다.</span>
						<div className="pd5"></div>
						</>
					}
					{ formData.status_view === 3 &&
						<>
						<span className='f_normal before_required'>추천서 제출이 완료된 지원서 입니다. 일부 정보를 열람하실 수 없습니다.</span>
						<div className="pd5"></div>
						</>
					}
				</div>
				</>
			}

			{ isCode && viewType=='edit' &&
				<>
				<div className={`${styles.info_box}`}>
					{ formData.status_view === 1 &&
						<>
						<span className='f_normal before_required'>{formData.nameKR}{formData.nameEN && formData.nameEN!=='' && `(${formData.nameEN})`} 님의 지원서 입니다.</span>
						<div className="pd5"></div>
						</>
					}
					{ formData.status_view === 2 &&
						<>
						<span className='f_normal before_required'>{formData.nameKR}{formData.nameEN && formData.nameEN!=='' && `(${formData.nameEN})`} 님의 제출이 완료된 지원서 입니다.</span>
						<div className="pd5"></div>
						<span className='f_normal before_required'>추천서 작성 메뉴로 이동하여 추천서를 작성해주세요.</span>
						<div className="pd5"></div>
						</>
					}
					{ formData.status_view === 3 &&
						<>
						<span className='f_normal before_required'>추천서 제출이 완료된 지원서 입니다. 일부 정보를 열람하실 수 없습니다.</span>
						<div className="pd5"></div>
						</>
					}
				</div>
				</>
			}

			<div className={styles.recommend_candidate_wrap}>
				<div className='p_i_sec'>
					<div>
						<span className='p_i_b_tit f_bigger f_bold'>1. 지원 부문</span>
					</div>
					<div className='p_i'>
						<span className='p_i_b_tit f_big f_bold'>회원 구분</span>
						<div className='p_i_con_box'>
							{memberGradeNameIDX.map((category) => {
								return (
									<div key={category.key} className='p_i_c_3'>
										<Checkbox
											inputId={category.key}
											name="memberGradeNameIDX"
											value={category}
											className="read_only_member_grade"
											checked={selected_memberGradeNameIDX.some((item) => item.value === category.value)}
										/>
										<label htmlFor={category.key} className="ml-2 f_normal">{category.name}</label>
									</div>
								);
							})}
						</div>
					</div>
					<div className="pd10"></div>
					<div className='p_i'>
						<span className='p_i_b_tit f_big f_bold'>전문 분과</span>
						<div className='p_i_con_box'>
							{letterDepartIDX.map((category) => {
								return (
									<div key={category.key} className='p_i_c_3'>
										<Checkbox
											inputId={category.key}
											name="letterDepartIDX"
											value={category}
											// onChange={onChg_letterDepartIDX}
											{...(viewType === 'nominee' && isCode && formData.status_view === 1) && {
												onChange: onChg_letterDepartIDX,
											}}
											checked={selected_letterDepartIDX.some((item) => item.value === category.value)}
										/>
										<label htmlFor={category.key} className="ml-2 f_normal">{category.name}</label>
									</div>
								);
							})}
						</div>
					</div>
					<div className="pd10"></div>
					<div className='p_i'>
						<span className='p_i_b_tit f_big f_bold'>업무 분야</span>
						<div className='p_i_con_box'>
							{workField.map((category) => {
								return (
									<div key={category.key}
										// className='p_i_c_3'
										className={category.name==='공공분야' ? 'mobile_mgt15px' : 'p_i_c_3'}
									>
										<Checkbox
											inputId={category.key}
											name="workField"
											value={category}
											// onChange={onChg_workField}
											{...(viewType === 'nominee' && isCode && formData.status_view === 1) && {
												onChange: onChg_workField,
											}}
											checked={selected_workField.some((item) => item.value === category.value)}
										/>
										<label htmlFor={category.key} className="ml-2 f_normal">{category.name==='공공분야' ? '공공 분야 (정부, 출연연, 공공기관 등)' : category.name}</label>
									</div>
								);
							})}
						</div>
					</div>
				</div>
				<div className='p_i_sec'>
					<div>
						<span className='p_i_b_tit f_bigger f_bold'>2. 지원자 인적사항</span>
					</div>
					<div className=' p_i_row'>
						<div className='p_i p_i_3'>
							<span className='p_i_tit f_small f_bold'>성명</span>
							<span className='p_i_con'>{formData.nameKR || ''}</span>
						</div>
						<div className='p_i p_i_3 p_i_registNumber'>
							<span className='p_i_tit f_small f_bold'>주민등록번호</span>
							{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
								<>
								<div className='p_i_con_box p_i_c_b_registNumber'>
									<InputText
										keyfilter='num'
										className='p_ip nomi_registNumber_birthday'
										maxLength={6}
										value={registNumber1}
										onInput={onChg_registNumber1}
									/>
									<span>-</span>
									<InputText
										keyfilter='num'
										className='p_ip nomi_registNumber_sex'
										maxLength={1}
										value={registNumber2}
										onInput={onChg_registNumber2}
										ref={registNumber2Ref}
									/>
									<span className='nomi_registNumber_mosaic'> * * * * * *</span>
								</div>
								</>
							) : (
								<span className='p_i_con'>{registNumber1 || ''}-{registNumber2 || ''} * * * * * *</span>
							)}
						</div>
						<div className='p_i p_i_3'>
                            <span className='p_i_tit f_small f_bold'>국적</span>
							<span className='p_i_con'>{formData.nation || ''}</span>
						</div>
					</div>
					
					<div className='p_i'>
						<span className='f_normal f_bold'>현직</span>
					</div>
					<div className='p_i_row'>
						<div className='p_i p_i_3'>
                            <span className='p_i_tit f_small f_bold'>기관</span>
							{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
								<div className='p_i_con_box'>
									<input type="text" className='p_ip'
										value={formData.organizationKR || ''}
										onChange={(e) => setFormData((prevData) => ({ ...prevData, organizationKR: e.target.value }))}
									/>
								</div>
							) : (
								<span className='p_i_con'>{formData.organizationKR || ''}</span>
							)}
						</div>
						<div className='p_i p_i_3'>
                            <span className='p_i_tit f_small f_bold'>부서</span>
							{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
								<div className='p_i_con_box'>
									<input type="text" className='p_ip'
										value={formData.deptKR || ''}
										onChange={(e) => setFormData((prevData) => ({ ...prevData, deptKR: e.target.value }))}
									/>
								</div>
							) : (
								<span className='p_i_con'>{formData.deptKR || ''}</span>
							)}
						</div>
						<div className='p_i p_i_3'>
                            <span className='p_i_tit f_small f_bold'>직위</span>
							{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
								<div className='p_i_con_box'>
									<input type="text" className='p_ip'
										value={formData.positionKR || ''}
										onChange={(e) => setFormData((prevData) => ({ ...prevData, positionKR: e.target.value }))}
									/>
								</div>
							) : (
								<span className='p_i_con'>{formData.positionKR || ''}</span>
							)}
						</div>
					</div>
                    <div className='p_i_row p_i_row_addr'>
						{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
							<>
								<div className='p_i p_i_addrCode'>
									<span className='p_i_tit f_small f_bold'>직장주소</span>
									<div className='p_i_con_box p_i_c_b_addrCode '>
										<input type="text"
											className='p_ip'
											value={formData.addressCode || ''}
											onChange={(e) => setFormData((prevData) => ({ ...prevData, addressCode: e.target.value }))}
											onClick={openDaumPostCode}
											placeholder='우편번호'
											readOnly 
										/>
										<button onClick={openDaumPostCode} className='p_btn f_small'>주소 검색</button>
									</div>
								</div>
								<div className='p_i p_i_addr1'>
									<span className='p_i_tit f_small no_txt'>주소</span>
									<div className='p_i_con_box'>
										<input type="text"
											className='p_ip'
											value={formData.address || ''}
											onChange={(e) => setFormData((prevData) => ({ ...prevData, address: e.target.value }))}
											onClick={openDaumPostCode}
											placeholder='주소'
											readOnly 
										/>
									</div>
								</div>
								<div className='p_i p_i_addrDetail'>
									<span className='p_i_tit f_small no_txt'>상세주소</span>
									<div className='p_i_con_box'>
										<input type="text"
											className='p_ip'
											value={formData.addressDetail || ''}
											onChange={(e) => setFormData((prevData) => ({ ...prevData, addressDetail: e.target.value }))}
											placeholder='상세주소'
										/>
									</div>
								</div>
							</>
						) : (
							<>
								<div className='p_i '>
									<span className='p_i_tit f_small f_bold'>직장주소</span>
									<span className='p_i_con'>{formData.addressCode || ''} {formData.address || ''} {formData.addressDetail || ''}</span>
								</div>
							</>
						)}

					</div>
                    <div className='p_i_row'>
						<div className='p_i p_i_3 p_i_call'>
							<span className='p_i_tit f_small f_bold'>직장 번호</span>
							{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
								<>
									<div className='p_i_con_box p_i_c_b_phone'>
										<InputText
											keyfilter='num'
											className='p_ip'
											maxLength={3}
											value={companyCall1}
											onInput={onChg_companyCall1}
										/>
										<span>-</span>
										<InputText
											keyfilter='num'
											className='p_ip'
											maxLength={4}
											value={companyCall2}
											onInput={onChg_companyCall2}
											ref={companyCall2Ref}
										/>
										<span>-</span>
										<InputText
											keyfilter='num'
											className='p_ip'
											maxLength={4}
											value={companyCall3}
											onInput={onChg_companyCall3}
											ref={companyCall3Ref}
										/>
									</div>
								</>
							) : (
								<>
								<span className='p_i_con'>{companyCall1} - {companyCall2} - {companyCall3}</span>
								</>
							)}
						</div>
						<div className='p_i p_i_3 p_i_call'>
							<span className='p_i_tit f_small f_bold'>휴대 전화</span>
							{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
								<>
									<div className='p_i_con_box p_i_c_b_phone'>
										<InputText
											keyfilter='num'
											className='p_ip'
											maxLength={3}
											value={phone1}
											onInput={onChg_phone1}
										/>
										<span>-</span>
										<InputText
											keyfilter='num'
											className='p_ip'
											maxLength={4}
											value={phone2}
											onInput={onChg_phone2}
											ref={phone2Ref}
										/>
										<span>-</span>
										<InputText
											keyfilter='num'
											className='p_ip'
											maxLength={4}
											value={phone3}
											onInput={onChg_phone3}
											ref={phone3Ref}
										/>
									</div>
								</>
							) : (
								<>
								<span className='p_i_con'>{phone1} - {phone2} - {phone3}</span>
								</>
							)}
						</div>
						<div className='p_i p_i_3 p_i_mail'>
							<span className='p_i_tit f_small f_bold'>이메일</span>
							{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
								<>
								<div className='p_i_con_box '>
									<input type="text" className='p_ip'
										value={formData.email || ''}
										onChange={(e) => setFormData((prevData) => ({ ...prevData, email: e.target.value }))}
									/>
								</div>
								</>
							) : (
								<>
									<span className='p_i_con'>{formData.email || ''}</span>
								</>
							)}
						</div>
					</div>
				</div>

				<div className='p_i_sec'>
					<div>
						<span className='p_i_b_tit f_bigger f_bold'>3. 업 적</span>
					</div>
					<div className='p_i'>
						<span className='f_normal '>공학·기술인으로서 이룬 성취와 업적의 탁월성을 기술하시기 바랍니다. (2,500자 이내)</span>
					</div>
					<div
					className='p_i'
					style={{
						display:
						viewType === 'nominee' && isCode && formData.status_view === 1
							? ''
							: 'none',
					}}
					>
						<div className='nomi_editor_container nomi_achievement_editor_container' ref={editorAchiRef}></div>
						<span className="char_count">{countAchi.toLocaleString()}/{maxLenAchi.toLocaleString()}</span>
						{countAchi > maxLenAchi && (
							<span className="char_count_warning">{maxLenAchi.toLocaleString()}자를 초과하였습니다.</span>
						)}
					</div>

					{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
						<>
						</>
					) : (
						<>
						{/* <div className='p_i'>
							<div
							className='p_i_con htmltg'
							dangerouslySetInnerHTML={{ __html: formData.achievementRecord || '' }}
							/>
						</div> */}
						<div className='p_i'>
							<div
								className='p_i_con htmltg'
								dangerouslySetInnerHTML={{
								__html: (formData.achievementRecord || '').replace(/\n/g, '<br />'),
								}}
							/>
						</div>
						</>
					)}
				</div>

				<div className='p_i_sec'>
					<div>
						<span className='p_i_b_tit f_bigger f_bold'>4. 공학한림원 활동 내역 및 계획</span>
					</div>
					<div className='p_i'>
						<span className='f_normal '>공학한림원 활동 내역 및 계획을 기술하시기 바랍니다. (1,000자 이내)</span>
					</div>
					<div
					className='p_i'
					style={{
						display:
						viewType === 'nominee' && isCode && formData.status_view === 1
							? ''
							: 'none',
					}}
					>
						<div className='nomi_editor_container nomi_naekCareer_editor_container' ref={editorCareerRef}></div>
						<span className="char_count">{countCareer.toLocaleString()}/{maxLenCareer.toLocaleString()}</span>
						{countCareer > maxLenCareer && (
							<span className="char_count_warning">{maxLenCareer.toLocaleString()}자를 초과하였습니다.</span>
						)}
					</div>

					{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
						<>
						</>
					) : (
						<>
						<div className='p_i'>
							<div
							className='p_i_con htmltg'
							dangerouslySetInnerHTML={{
								// __html: formData.naekCareer || ''
								__html: (formData.naekCareer || '').replace(/\n/g, '<br />'),
							}}
							/>
						</div>
						</>
					)}
				</div>

				<div className='p_i_sec'>
					<div className=''>
						<span className='p_i_b_tit f_bigger f_bold'>파일 첨부</span>
					</div>
					<div className='p_i'>
						<span className={`before_required ${styles.nomi_file_info}`}>필수 첨부 : 이력서(3쪽 이내)</span>
						<span className={`before_required ${styles.nomi_file_info}`}>기타 첨부 : 대표업적 증빙자료(5건 이내) 등</span>
					</div>
					<div className='p_i'>
						<div className='p_i_con_box'>
							{formDataFileCount > 0 && formData.file.map((file, i) => (
								<div key={file.idx} className={styles.file_item}>
									<input className='p_ip' type="text" readOnly value={file.name} />
									{formData.status_view === 1 && isCode && viewType === 'nominee' ? (
										<>
											<button onClick={() => on_emptyFile(file)} className={`p_btn f_small ${styles.file_on}`}>삭제</button>
										</>
									) : isCode && viewType === 'edit' ? (
										<>
											<button onClick={() => on_downloadFile(file)} className={`p_btn f_small ${styles.file_on}`}>다운로드</button>
										</>
									) : null}

								</div>
							))}

							{formDataFileCount < 3 && (
								<>
									{viewType === 'nominee' && isCode && formData.status_view === 1 ? (
										<>
											<label htmlFor={`tmpFile_${formDataFileCount + 1}`} className={styles.file_item}>
												<input className='p_ip' type="text" readOnly value='선택된 파일 없음' style={{ flex: 1, pointerEvents: 'none' }} />
												<button className={`p_btn f_small p_btn_blue ${styles.file_on}`} onClick={() => document.getElementById(`tmpFile_${formDataFileCount + 1}`).click()}>파일선택</button>
											</label>
											<input
												type="file"
												id={`tmpFile_${formDataFileCount + 1}`}
												style={{display: 'none'}}
												onChange={onChg_file}
											/>
										</>
									) : (
										<>
										</>
									)}
								</>
							)}
						</div>
					</div>
				</div>

				<div className={styles.nomi_bottom_member_wrap}>
					<div>
						<span className='p_i_b_tit f_bigger f_bold'>추천자</span>
					</div>
					<div className=' p_i_row'>
						<div className='p_i p_i_3'>
							<span className='p_i_tit f_small f_bold'>성 명</span>
							<span className='p_i_con'>{formData.member_name || ''}</span>
						</div>
						<div className='p_i p_i_3 p_i_registNumber'>
							<span className='p_i_tit f_small f_bold'>현 직</span>
							<span className='p_i_con'>{formData.member_organization || ''}</span>
						</div>
						<div className='p_i p_i_3'>
                            <span className='p_i_tit f_small f_bold'>이메일</span>
							<span className='p_i_con'>{formData.member_email || ''}</span>
						</div>
					</div>
					<div className={styles.nomi_bottom_info_box}>
						<span className='f_normal'>* 한국공학한림원 정회원 또는 단체회원의 대표에게 공학한림원 회원 추천권이 있습니다.</span>
						<span className='f_normal'>* 지원서 제출이 완료되면 추천자에게 추천서 작성 요청 이메일이 발송되며, 내용을 수정할 수 없습니다.</span>
					</div>
				</div>
			</div>

			<div className={styles.recommend_candidate_foot_wrap}>
				{ viewType=='nominee' && isCode && formData.status_view=== 1 &&
					<>
					<div className='p_i_sec'>
						<div className='p_i'>
							<div className='p_i_con_box'>
								<span className='f_normal before_required'>한국공학한림원 회원심사를 위한 지원서를 작성함에 있어 사실 그대로 거짓 없이 작성하며 허위 사실이나 결격사유가 있을 경우, 지원을 취하할 것을 서약합니다.</span>
							</div>
						</div>
					</div>
					<div className='p_i_sec'>
						<div className='p_i'>
							<div className='p_i_con_box center'>
								{/* {
								formData.statusIDX=== 1 && formData.status==='기본추천서 통과' &&
									<> */}
									<button onClick={() => nomineeEdit('save')} className='p_btn p_btn_normal'>임시저장</button>
									<button onClick={() => nomineeEdit('submit')} className='p_btn p_btn_normal p_btn_blue mgl10'>제출</button>
									{/* </>
								} */}
							</div>
						</div>
					</div>
					</>
				}
			</div>
		</div>
		</>
	);
}

































































function LoginNomiList({ onEdit }) {
	const { useAlert, useLoading } = common();
	const { pAlert, AlertComponent } = useAlert();
	const { pLoadingOn, pLoadingOff,LoadingComponent} = useLoading();

	const [getData, setGetData] = useState([]);//
	const [getDataLen, setGetDataLen] = useState(0);//


    useEffect(() => {
        const fetchData = async () => {
            try {
                pLoadingOn();
                const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/in/get_my_nomi_list`,{  }, { withCredentials: true });
                if (response.data && response.data.result === 't') {
					const tmpData = response.data.data;
					setGetDataLen(tmpData.length);
					setGetData(tmpData);
                } else {
					
                }
            } catch (error) {
                console.error('실패:', error);
            } finally {
                setTimeout(() => {
                    pLoadingOff();
                },300);
            }
        };
        fetchData();
    }, []);

        
	const onRowSelect = async (e) => {
		try {
			pLoadingOn();
			const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/out/access_nomi`, { code: e.value.code }, { withCredentials: true });
			if (response && response.data && response.data.result === 't') {
				onEdit(response.data.data);
			} else {
				console.error(response.data);
				pAlert(response.data.msg);
			}
		} catch (error) {
			console.error('실패:', error);
		} finally {
			setTimeout(() => {
				pLoadingOff();
			}, 300);
		}
	};

	
	return (
		<>
		<LoadingComponent />
		<div className='components_wrap'>
			<div className='p_i_sec'>
				{getDataLen !== 0 && (
					<div className='naek_table table_mo_min_w_600'>
						<DataTable value={getData} selectionMode="single" onSelectionChange={onRowSelect} dataKey="idx">
							<Column field="idx" header="-"
								style={{ display: 'none' }}
								headerStyle={{ display: 'none' }}
								bodyStyle={{ display: 'none' }}
							></Column>
							<Column field="createTime" header="등록일" bodyClassName="text-center"></Column>
							<Column field="status" header="상태" bodyClassName="text-center"></Column>
							<Column field="nameKR" header="후보자" bodyClassName="text-center"></Column>
							<Column field="organizationKR" header="기관" bodyClassName="text-center"></Column>
							{/* <Column field="deptKR" header="부서" bodyClassName="text-center"></Column> */}
							<Column field="positionKR" header="직위" bodyClassName="text-center"></Column>
							<Column field="email" header="이메일" bodyClassName="email_fontmask"
								body={(rowData) => (
									<span dangerouslySetInnerHTML={{ __html: rowData.email }} />
								)}></Column>
							<Column field="code" header="-"
								style={{ display: 'none' }}
								headerStyle={{ display: 'none' }}
								bodyStyle={{ display: 'none' }}
							></Column>
						</DataTable>
					</div>
				)}
			</div>
			{getDataLen === 0 && (
				<div className={styles.code_wrap}>
					<div className='p_i_sec'>
					</div>
				</div>
			)}
		</div>
		</>
	);
}







































































function CodeInput({ onSubmitCode }) {
	const { useAlert, useLoading } = common();
	const { pAlert, AlertComponent } = useAlert();
	const { pLoadingOn, pLoadingOff,LoadingComponent} = useLoading();

	const [code, setCode] = useState('');//입력하는 코오드

	const CodeSubmit = async () => {
        try {
            pLoadingOn();
			const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/out/access_nomi`, { code: code }, { withCredentials: true });
            if (response && response.data && response.data.result === 't') {
				onSubmitCode(response.data.data);
            } else {
                console.error(response.data);
				pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('실패:', error);
        } finally {
            setTimeout(() => {
                pLoadingOff();
            }, 300);
        }
    };

	return (
		<>
		<AlertComponent />
		<LoadingComponent />

		<div className='components_wrap'>
			<div className={styles.code_wrap}>

				<div className='p_i_sec'>
					<div className='p_i'>
						<div className='p_i_con_box center'>
							<span className='f_bigger f_bold'>이메일로 전달받은 코드를 입력해주세요.</span>
						</div>
					</div>
				</div>
				<div className='p_i_sec'>
					<div className='p_i'>
						<div className='p_i_con_box center'>
							<input type="text" className='p_ip' onChange={(e) => setCode(e.target.value)} />
						</div>
					</div>
					<div className='p_i'>
						<div className='p_i_con_box center'>
							<button onClick={CodeSubmit} className='p_btn p_btn_normal p_btn_blue '>제출</button>
						</div>
					</div>
				</div>
				<div className='p_i_sec'>
					<div className='p_i'>
						<div className='p_i_con_box flex_center'>
							<span className='f_normal before_required'>본인이 아닐 시 이용에 제한이 있을 수 있습니다.</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		</>
	);
}





































































function App({isLogin}) {
	const [currentScreen, setCurrentScreen] = useState('');
	const [tempCode, setTempCode] = useState('');
	// const [tempIdx, setTempIdx] = useState('');
	const navigate = useNavigate();
    const location = useLocation();
	
    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const view = query.get('view');
        const code = query.get('code');
        // const idx = query.get('idx');
        
        setCurrentScreen(view || '');
        setTempCode(code || '');
        // setTempIdx(idx || '');
    }, [location.search]);

	const moveList = () => {
		setCurrentScreen('list');
		navigate('?view=list');
	};


	const moveEdit = (code) => {
		setTempCode(code);
		setCurrentScreen('edit');
		navigate(`?view=edit&code=${code}`);
	};

	const moveCodeSubmit = (code) => {
		setTempCode(code);
		setCurrentScreen('nominee');
		navigate(`?view=nominee&code=${code}`);
	};

	// 찐버전용 isLogin 을 달아야 함
	if(isLogin){
		if(currentScreen==='edit'){
			return <NomiDetail viewType='edit' onList={moveList} isCode={tempCode} />;
		}
		return <LoginNomiList onEdit={moveEdit} />;
	}
	if(currentScreen==='nominee'){
		return <NomiDetail viewType='nominee' isCode={tempCode} />;
	}
	return <CodeInput onSubmitCode={moveCodeSubmit} />
}

export default App;